import { Order } from '@api/order/order.models';

export const getSubStatusOrder = (order: Partial<Order>): string | null => {
    if (!order.orderTracking || Object.keys(order.orderTracking).length === 0) {
        return null;
    }

    const orderTrackingKeys = Object.keys(order.orderTracking);
    const firstOrderKey = orderTrackingKeys[0];
    const firstOrderData = order.orderTracking[firstOrderKey];

    if (!firstOrderData.statusTracking || firstOrderData.statusTracking.length === 0) {
        return null;
    }

    const lastStatusTracking = firstOrderData.statusTracking[firstOrderData.statusTracking.length - 1];

    return lastStatusTracking.subStatus;
};
